import React from 'react'

const LeftArrowIcon: React.FC = (props) => (
	<svg {...props} width='44' height='48' viewBox='0 0 44 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M41.3291 2.65833L2.5 24.5L21.9146 34.9208L41.3291 45.3416'
			stroke='currentColor'
			strokeWidth='5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
)

export default LeftArrowIcon
